

export const getters = {
    systemAttendances: state => state.attendances,
    systemAttendance: state => state.attendance,
    Attendance: state => state.systemAttend
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/attendances/getters.js